import React from 'react';
import { Link } from 'react-router-dom';
import contactInfo from '../config/contactInfo';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <div className="flex items-center mb-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="h-8 w-8 text-orange-600 mr-2"
                aria-hidden="true"
              >
                <path d="M10 10V5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v5"></path>
                <path d="M14 6a6 6 0 0 1 6 6v3"></path>
                <path d="M4 15v-3a6 6 0 0 1 6-6"></path>
                <rect x="2" y="15" width="20" height="4" rx="1"></rect>
              </svg>
              <span className="text-xl font-bold">{contactInfo.companyName}</span>
            </div>
            <p className="text-gray-400">
              {contactInfo.tagline}
            </p>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-gray-400">
              <li><Link to="/" className="hover:text-white transition-colors">Home</Link></li>
              <li><Link to="/about" className="hover:text-white transition-colors">About</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Info</h4>
            <div className="space-y-2 text-gray-400">
              <p>{contactInfo.phone}</p>
              <p>{contactInfo.email}</p>
              <p>
                {contactInfo.address.street}<br />
                {contactInfo.address.city}, {contactInfo.address.province} {contactInfo.address.postalCode}
              </p>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>© 2024 {contactInfo.companyName}. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;